import { Routes } from '@angular/router';
import { authGuardFn } from '@auth0/auth0-angular';

import { LandingRoutes } from './landing/landing.routes';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => LandingRoutes,
  },
  {
    path: '',
    canActivate: [authGuardFn],
    children: [
      {
        path: 'admin',
        loadChildren: () =>
          import('./admin/admin.routes').then((m) => m.adminRoutes),
      },
      {
        path: 'billing',
        loadChildren: () =>
          import('./billing/billing.routes').then((m) => m.billingRoutes),
      },
      {
        path: 'clients',
        loadChildren: () =>
          import('./clients/clients.routes').then((m) => m.clientsRoutes),
      },
      {
        path: 'payments/customer-search',
        loadChildren: () =>
          import('./customer/customer.routes').then((m) => m.customerRoutes),
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./home/home.routes').then((m) => m.dashboardRoutes),
      },
      {
        path: 'hq',
        loadChildren: () => import('./hq/hq.routes').then((m) => m.hqRoutes),
      },
      {
        path: 'me',
        loadChildren: () => import('./me/me.routes').then((m) => m.meRoutes),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./notifications/notifications.routes').then(
            (m) => m.notificationsRoutes,
          ),
      },
      {
        path: 'payments/elbx',
        loadChildren: () =>
          import('./elbx/elbx.routes').then((m) => m.elbxRoutes),
      },
      {
        path: 'payments',
        loadChildren: () =>
          import('./payments/payments.routes').then((m) => m.paymentsRoutes),
      },
      {
        path: 'reporting/elbx',
        loadChildren: () =>
          import('./reporting/elbx-reporting.routes').then(
            (m) => m.elbxReportingRoutes,
          ),
      },
      {
        path: 'reporting',
        loadChildren: () =>
          import('./reporting/reporting.routes').then((m) => m.reportingRoutes),
      },
      {
        path: 'tools',
        loadChildren: () =>
          import('./tools/tools.routes').then((m) => m.toolsRoutes),
      },
    ],
  },

  // The '**' route needs to appear last so that it is the catch-all for not found.
  {
    path: '**',
    redirectTo: '/page-not-found',
  },
];
